import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-instant-courses',
  templateUrl: './get-instant-courses.component.html',
  styleUrls: ['./get-instant-courses.component.scss']
})
export class GetInstantCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
